const TitleBlockView = ({ properties, metadata }) => {
  return (
    <h1 className="documentFirstHeading">
      <span>{(metadata || properties)['title'] || ''}</span>
    </h1>
  );
};

export default TitleBlockView;
